/**
 * * Модель инициализации загрузки видеофайлов
 */
export class InitAddVideosRequestModel {
  /**ID папки */
  FolderId!: string;
  /**ID задачи */
  TaskId?: number;
  /**ID очереди */
  QueueTaskId?: string;
  /**ID чата */
  ChatId?: string;
  /**Список файлов */
  Files!: Array<{
    /**Название файла */
    FileName: string;
    /**Размер файла */
    FileSize: number;
    /**Обложка видео */
    Thumbnail?: string;
  }>;

  constructor(obj?: Partial<InitAddVideosRequestModel>) {
    Object.assign(this, obj);
  }
}
